export default function CopyrightFooter() {
  return (
    <footer data-testid="copyright-footer" className="room-hide relative z-[720] h-7 shrink-0 bg-[#050810] border-t border-white/5 flex items-center justify-center gap-2 sm:gap-3 px-2">
      <img data-testid="footer-company-logo" src="/zeefa_logo_white.png" alt="Zeefa Technologies" className="h-4 sm:h-5 w-auto shrink-0" />
      <span data-testid="footer-copyright-text" className="font-mono-t text-[8px] sm:text-[10px] text-slate-400 sm:tracking-wide whitespace-nowrap">
        © 2026 ZEEFA TECHNOLOGIES. All rights reserved.
      </span>
    </footer>
  );
}
